import * as React from "react";
import { Collapse } from "react-collapse";
import Container from "./styled";

class DropdownItemArrepentimiento extends React.Component {
  render() {
    return (
      <Container>
        <button
          className={this.props.isActive ? "headerBarOpen" : "headerBarClose"}
          onClick={this.props.clickFunction}
        >
          <h4>{this.props.title}</h4>
          {this.props.isCompleted}
        </button>
        <Collapse isOpened={this.props.isActive}>
          <div className="displayText">{this.props.children}</div>
        </Collapse>
      </Container>
    );
  }
}

export default DropdownItemArrepentimiento;
